/**
 * Determines which provider gets which best practice document.
 * Keyed by the provider type
 */
const BestPracticeDocumentMap = {
  1: "dokiapp-orvosi-szakmai-best-practice-20210318.pdf",
  2: "dokiapp-pszichologus-best-practice-20210318.pdf"
};

export default BestPracticeDocumentMap;